import { Component, Inject } from '@angular/core';
import { DialogBelonging } from '@costlydeveloper/ngx-awesome-popup';
import { faTick, faTicket } from '@fortawesome/pro-regular-svg-icons';
import { Subscription } from 'rxjs';
import { SalesReportService } from 'src/app/services/sales-report.service';

@Component({
  selector: 'app-dialog-payment-confirm',
  templateUrl: './dialog-payment-confirm.component.html',
  styleUrls: ['./dialog-payment-confirm.component.scss'],
})
export class DialogPaymentConfirmComponent {
  faTicket = faTicket;

  private subscriptions: Subscription = new Subscription();
  private data: any;

  constructor(
    private salesReportService: SalesReportService,
    @Inject('dialogBelonging') public dialogBelonging: DialogBelonging
  ) { }

  ngOnInit() {
    document.getElementsByClassName('ed-btn-info ')[0].innerHTML =
      '<i class="fa-regular fa-print"></i>';

    // Check received data and other available features.
    this.data = this.dialogBelonging;

    // Subscribe to button listeners.
    this.subscriptions.add(
      // IDialogEventsController
      this.dialogBelonging.eventsController.onButtonClick$.subscribe(


        (_Button) => {

          if (_Button.ID === 'info') {
            this.viewTicket(
              this.data.customData.channel,
              this.data.customData.id
            );

            this.dialogBelonging.eventsController.close();

          }
          else if (_Button.ID === 'submit') {
            this.viewThermalTicket(
              this.data.customData.channel,
              this.data.customData.id
            );

            this.dialogBelonging.eventsController.close();

          } else if (_Button.ID === 'cancel') {

            // Do some logic and close popup.
            this.dialogBelonging.eventsController.close();

            // this.dialogBelonging.eventsController?.close();
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();

  }
  viewThermalTicket(channel: any, id: any) {
    this.salesReportService
      .getPrintUrlTicket(id)
      .subscribe((res: any) => {
        window.open(res.data.ticket, '_blank');
      });
  }

  viewTicket(channel: any, id: any) {
    this.salesReportService
      .getPrintUrlTicket(id)
      .subscribe((res: any) => {
        window.open(res.data.ticket_a4, '_blank');
      });
  }
}
